<template>
  <div class="app-container">
    <BjRouteTabs :route-list="ORDER_ABNORMAL_FIVE_ROUTE_LIST" />
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :default-sort="defaultSort" :get-action="queryApi" :serial="serial" :before-reset-search="beforeResetSearch" :tooltip-config="{ contentMethod: false, enterable: true }" :selection="selection" @sort-change="sortChange" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <BjSelectChannelStore :span="colSpan" :query-params="queryParams" :query-props="['channel', 'storeIdList']" multiple />
        <el-col :span="colSpan">
          <el-form-item :label="$t('InternalOrder.No')" prop="orderNo">
            <BjInput v-model="queryParams.orderNo" :placeholder="$t('InternalOrder.No')" comma @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('InternalOrder.order')">
            <BjDateRangePicker v-model="queryParamsTime_order" :placeholder="$t('InternalOrder.order')" />
          </el-form-item>
        </el-col>
        <el-col v-if="!$store.getters.cusId" :span="colSpan">
          <el-form-item :label="$t('billingPage.CustomerName')" prop="cusId">
            <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation></template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
              <template v-else-if="col.prop === 'outerOrderNo'">
                <span>{{ scope.row.webReference }}</span>
                <BjCopyIcon :copy="scope.row.webReference" />
              </template>
              <template v-else-if="col.prop === 'totalOrderStatus'">
                <el-tag :type="scope.row[col.prop] === 8 ? 'success' : 'info'">{{
                  $t(ORDER_INTERNAL_ALL_STATUS_LIST.bjGet(scope.row[col.prop]))
                }}</el-tag>
              </template>
              <template v-else-if="col.prop === 'orderHandleStatus'">
                {{ [0,6].includes(scope.row[col.prop]) ? $t(ORDER_WMS_STATUS_LIST.bjGet(scope.row[col.prop])) : ''}}
              </template>
              <template v-else-if="col.prop === 'orderStatusStr'">
                <el-tag :type="scope.row[col.prop] === 'Proccessing' ? 'success' : 'info'">{{ scope.row[col.prop] }}</el-tag>
              </template>
              <template v-else-if="col.prop === 'pickUpTime'">
                <span>{{ scope.row[col.prop] ? 'Yes' : '' }}</span>
              </template>
              <template v-else-if="col.prop === 'shippingMethod'">
                <el-tag>{{ $t(CSG_ORDER_SHIPPING_METHODS_LIST.bjGet(scope.row[col.prop])) }}</el-tag>
              </template>

              <template v-else-if="col.prop === 'creationDate'">
                <span>{{ scope.row[col.prop] | timeOperateTwoHour }}</span>
              </template>
              <template v-else-if="col.prop === 'failureReason'">
                {{ $t(LANG_ZH_EN_PS_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="col.prop === 'orderTime'">
                <span>{{ scope.row[col.prop] | timeOptimization }}</span>
              </template>
              <template v-else-if="col.prop === 'lastUpdateDate'">
                <span>{{ scope.row[col.prop] | timeOperateTwoHour }}</span>
              </template>
              <template v-else-if="col.prop === 'isNeedQuota'">
                <span>{{ scope.row.shippingMethod && scope.row.shippingMethod.toLowerCase().includes('csg manual') ? (scope.row.isNeedQuota?'Yes':' ') : ' ' }}</span>
              </template>
              <template v-else-if="col.prop === 'quotedAmount'">
                <span>{{ scope.row.shippingMethod && scope.row.shippingMethod.toLowerCase().includes('csg manual') ? scope.row.quotedAmount : ' ' }}</span>
              </template>
              <template v-else-if="col.prop === 'quotaOrNot'">
                <el-tag v-if="scope.row.shippingMethod && scope.row.shippingMethod.toLowerCase().includes('csg manual')">{{ $t(ORDER_QUOTE_TYPES_STATUS.bjGet(scope.row[col.prop])) }}</el-tag>
                <span v-else>{{' '}}</span>
              </template>
              <template v-else-if="col.prop === 'isProvideSize'">
                <span>{{ scope.row.shippingMethod && scope.row.shippingMethod.toLowerCase().includes('customer manual')?(scope.row.isProvideSize?'Yes':' '):" " }}</span>
              </template>
              <template v-else-if="col.prop === 'isSizeWrite'">
                <span>{{ scope.row.shippingMethod && scope.row.shippingMethod.toLowerCase().includes('customer manual')?(scope.row.repLength?'Yes':' '):" " }}</span>
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-button type="text" class="edit-btn" @click="toViewOrder(props.row)">{{ $t('viewText') }}</el-button>
              <el-dropdown v-hasDropdownChildren @command="command($event, props.row)">
                <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i class="el-icon-arrow-down el-icon--right" /></span>
                <el-dropdown-menu slot="dropdown">
                  <!-- SCG -->
                  <el-dropdown-item v-if="props.row.shippingMethod&&props.row.shippingMethod.toLowerCase().includes('csg manual')&&!$store.getters.cusId" :disabled="props.row.isNeedQuota && props.row.quotaOrNot!=2" command="fillInLabel"> {{ $t('WarehouseManagement.form.Label') }} </el-dropdown-item>
                  <el-dropdown-item v-if="props.row.shippingMethod&&props.row.shippingMethod.toLowerCase().includes('csg manual')&&!$store.getters.cusId" :disabled="!props.row.isNeedQuota || props.row.quotaOrNot==2" command="fillInPrice"> {{ $t('WarehouseManagement.form.Quote') }} </el-dropdown-item>
                  <el-dropdown-item v-if="props.row.shippingMethod&&props.row.shippingMethod.toLowerCase().includes('csg manual')&&$store.getters.cusId" :disabled="!props.row.isNeedQuota || props.row.quotaOrNot!=1" command="ConfirmPrice"> {{ $t('WarehouseManagement.form.isQuotation') }} </el-dropdown-item>
                  <!-- customer -->
                  <el-dropdown-item v-if="props.row.shippingMethod=='CUSTOMER MANUAL'" :disabled="props.row.isProvideSize && ![props.row.repLength,props.row.repWidth,props.row.repHeight,props.row.repWeight].every(e=>{return e > 0})" command="fillInLabel"> {{ $t('WarehouseManagement.form.Label') }} </el-dropdown-item>
                  <el-dropdown-item v-if="props.row.shippingMethod=='CUSTOMER MANUAL'&&!$store.getters.cusId" :disabled="!props.row.isProvideSize || ![props.row.repLength,props.row.repWidth,props.row.repHeight,props.row.repWeight].every(e=>{return e == null})" command="fillInSize"> {{ $t('WarehouseManagement.form.Dimension') }} </el-dropdown-item>
                  <!-- SCG 、customer 共用 -->
                  <el-dropdown-item command="ModifyTrans"> {{ $t('WarehouseManagement.form.Shipping') }} </el-dropdown-item>
                  <el-dropdown-item :disabled="[0,6].includes(props.row.orderHandleStatus)" command="cancel"> {{ $t('cancelText') }} </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <delveryDialog ref="delveryDialogRef" @reFresh="reFresh" />
    <!-- 报价弹框 -->
    <el-dialog :title="`${$t('editText')}${$t('goodsSku.detail.Price')} (AUD)`" :visible.sync="dialogFormVisible" width="400px">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item prop="quotedAmount" :label="$t('goodsSku.detail.Price')+':'">
          <BjInputMoney :disabled="form.isDisabled" v-model="form.quotedAmount" placeholder="AUD" style="width: 300px;text-decoration-color:brown" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="!form.isDisabled" @click="dialogFormVisible = false">{{ $t('cancelText') }}</el-button>
        <el-button v-if="!form.isDisabled" type="primary" @click="saveAmount()">{{ $t('saveText') }}</el-button>
        <el-button v-if="form.isDisabled" type="primary" @click="cancelAmount()">{{ $t('WarehouseManagement.form.refuse') }}</el-button>
        <el-button v-if="form.isDisabled" type="primary" @click="doneAmount()">{{ $t('WarehouseManagement.form.agree') }}</el-button>
      </div>
    </el-dialog>
    <!-- 运输方式弹框 -->
    <el-dialog :title="$t('WarehouseManagement.form.Shipping')" v-if="dialogShippingVisible" :visible.sync="dialogShippingVisible" width="400px">
      <el-form ref="Shippingform" :model="Shippingform" :rules="ShippingformRules">
        <el-form-item prop="shippingMethod" :label="$t('orderNewPatch.Shipping')+':'">
          <BjSelectLov v-model="Shippingform.shippingMethod" :option-list="ShippingList" />
        </el-form-item>
        
        <el-form-item prop="isNeedQuota" :label="$t('WarehouseManagement.form.Quotation')+':'" v-if="Shippingform.shippingMethod == 'CSG MANUAL'">
          <BjSelectLov v-model="Shippingform.isNeedQuota" :option-list="STATUS_YES_TRUE" />
        </el-form-item>
        <el-form-item prop="isProvideSize" :label="$t('WarehouseManagement.form.check')+':'" v-if="Shippingform.shippingMethod == 'CUSTOMER MANUAL'">
          <BjSelectLov v-model="Shippingform.isProvideSize" :option-list="STATUS_YES_TRUE" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogShippingVisible = false">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="updateShapping()">{{ $t('okText') }}</el-button>
      </div>
    </el-dialog>
    <!-- 尺寸弹框 -->
    <el-dialog :title="$t('WarehouseManagement.form.Dimension')" :visible.sync="dialogSizeVisible" width="400px">
      <el-form ref="SizeForm" :model="SizeForm" :rules="SizeFormRules">
        <el-form-item :label="$t('WarehouseManagement.form.Length')" prop="repLength">
          <BjInputMoney v-model="SizeForm.repLength">
            <template slot="append">cm</template>
          </BjInputMoney>
        </el-form-item>
        <el-form-item :label="$t('WarehouseManagement.form.Width')" prop="repWidth">
          <BjInputMoney v-model="SizeForm.repWidth">
            <template slot="append">cm</template>
          </BjInputMoney>
        </el-form-item>
        <el-form-item :label="$t('WarehouseManagement.form.Height')" prop="repHeight">
          <BjInputMoney v-model="SizeForm.repHeight">
            <template slot="append">cm</template>
          </BjInputMoney>
        </el-form-item>
        <el-form-item :label="$t('WarehouseManagement.form.Weight')" prop="repWeight">
          <BjInputMoney v-model="SizeForm.repWeight">
            <template slot="append">kg</template>
          </BjInputMoney>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogSizeVisible = false">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="updateSize()">{{ $t('okText') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import delveryDialog from './delveryDialog';
import { orderApi } from '@/api';
import {
  CSG_ORDER_INTERNAL_ORDER_STATUS_CSG_LIST,
  ORDER_INTERNAL_HAND_UP_STATUS_LIST,
  ORDER_INTERNAL_ALL_STATUS_LIST,
  ORDER_WMS_STATUS_LIST,
  CSG_ORDER_SHIPPING_METHODS_LIST,
  ORDER_QUOTE_TYPES_STATUS,
  LANG_ZH_EN_PS_LIST,
  STATUS_YES_TRUE
} from '@/utils/constants';
import { getShippingList } from '@/utils/index';

export default {
  name: 'BusinessAbnormalOrderWAIRING',
  components: { delveryDialog },
  mixins: [pageMiXin],
  props: {},
  data() {
    return {
      STATUS_YES_TRUE,
      selection: true,
      colSpan: 4,
      CSG_ORDER_INTERNAL_ORDER_STATUS_CSG_LIST,
      ORDER_INTERNAL_HAND_UP_STATUS_LIST,
      ORDER_INTERNAL_ALL_STATUS_LIST,
      ORDER_WMS_STATUS_LIST,
      CSG_ORDER_SHIPPING_METHODS_LIST,
      ORDER_QUOTE_TYPES_STATUS,
      LANG_ZH_EN_PS_LIST,
      queryApi: orderApi.getCSGThirdOrderPage,
      // 查询参数
      queryParamsTime_order: [],
      queryParams: {
        cusId: null,
        channel: null,
        orderEndTime: null,
        orderNo: null,
        orderStartTime: null,
        storeId: null,
        storeIdList: [],
        totalOrderStatus: [8],

        sortParam: null,
        sortOrder: null,

      },
      labelList1: [
        { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false, width: '100' },
        { label: this.$t('InternalOrderListcompent.name'), prop: 'receiverName', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.number'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: '190' },
        { label: this.$t('InternalOrder.form.wmsOrderNo'), prop: 'sapOrderNo', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('orderNewPatch.Status'), prop: 'totalOrderStatus', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('orderNewPatch.wmsStatus'), prop: 'orderHandleStatus', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('InternalOrder.form.channel'), prop: 'channelTypeMeaning', isCheck: true, disabled: false, width: '110'},
        { label: this.$t('InternalOrder.form.Sales'), prop: 'storeName', isCheck: true, disabled: false, width: '124'},
        { label: this.$t('orderNewPatch.Shipping'), prop: 'shippingMethod', isCheck: true, disabled: false, width: '200'},
        { label: this.$t('InternalOrder.form.document'), prop: 'logisticsNo', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('orderNewPatch.Ordered'), prop: 'orderTime', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('orderNewPatch.Created'), prop: 'creationDate', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('orderNewPatch.delivery'), prop: 'hjShipmentTime', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('orderNewPatch.ShippingCost'), prop: 'totalPrice', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('orderNewPatch.Courier'), prop: 'logisticsCompany', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('WarehouseManagement.form.Quotation'), prop: 'isNeedQuota', isCheck: true, disabled: false },
        { label: this.$t('WarehouseManagement.form.amount'), prop: 'quotedAmount', isCheck: true, disabled: false },
        { label: this.$t('WarehouseManagement.form.quotationStatus'), prop: 'quotaOrNot', isCheck: true, disabled: false,width: '105' },
        { label: this.$t('WarehouseManagement.form.check'), prop: 'isProvideSize', isCheck: true, disabled: false },
        { label: this.$t('WarehouseManagement.form.filled'), prop: 'isSizeWrite', isCheck: true, disabled: false },
        { label: this.$t('InternalSalesOrderDetails.Customer'), prop: 'serviceRemarks', isCheck: false, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: '150' },
      ],
      defaultSort: [],
      dialogFormVisible: false,
      form: {
        innerOrderNo:null,
        totalOrderStatus:null,
        isDisabled: false,
      },
      rules:{
        quotedAmount: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
      
      dialogShippingVisible: false,
      Shippingform: {
        shippingMethod:'CUSTOMER MANUAL',
        isNeedQuota: null,
        isProvideSize: null,
      },
      ShippingList: [],
      
      dialogSizeVisible: false,
      SizeForm: {
        repLength:'0.00',
        repWidth:'0.00',
        repHeight:'0.00',
        repWeight:'0.00',
      },
      SizeFormRules:{
        repLength: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        repWidth: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        repHeight: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        repWeight: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
      ShippingformRules: {
        shippingMethod: { required: true, message: this.$t('chooseText'), trigger: 'change' },
        isNeedQuota: { required: true, message: this.$t('chooseText'), trigger: 'change' },
        isProvideSize: { required: true, message: this.$t('chooseText'), trigger: 'change' },
      }
    };
  },
  computed: {
    labelList() {
        return this.$store.getters.cusId ? this.labelList1.filter(item => item.prop != 'cusId') : this.labelList1;
    },
  },
  watch: {
    queryParamsTime_order(v) {
      this.queryParams.orderStartTime = (v || [])[0];
      this.queryParams.orderEndTime = (v || [])[1];
    },
  },
  methods: {
    sortChange (column) {
      switch (column.property) {
        case 'orderTime':
          this.queryParams.sortParam = column.property;
          this.queryParams.sortOrder = column.order;
          break;
        case 'creationDate':
          this.queryParams.sortParam = column.property;
          this.queryParams.sortOrder = column.order;
          break;
      }
      this.defaultSort = [{ field: column.field, order: column.order }];
      this.$refs.BjPage.fetchData();
    },
    // 跳转内部订单详情
    toViewOrder(row) {
      if(row.shippingMethod=='CSG MANUAL'){
        if(!(row.isNeedQuota && row.quotaOrNot!=2)){
          // 内部订单详情页
          this.$router.push({
            name: 'BusinessOrderInternalViewCSG',
            query: { id: '', code: row.innerOrderNo, type: 'edit', status: row.totalOrderStatus, orderHandleStatus: row.orderHandleStatus },
          });
        }else{
          // 内部订单详情页
          this.$router.push({
            name: 'BusinessOrderInternalViewCSG',
            query: { id: '', code: row.innerOrderNo, status: row.totalOrderStatus, orderHandleStatus: row.orderHandleStatus },
          });
        }
      }
      if(row.shippingMethod=='CUSTOMER MANUAL'){
        if(!(row.isProvideSize && ![row.repLength,row.repWidth,row.repHeight,row.repWeight].every(e=>{return e > 0}))){
          // 内部订单详情页
          this.$router.push({
            name: 'BusinessOrderInternalViewCSG',
            query: { id: '', code: row.innerOrderNo, type: 'edit', status: row.totalOrderStatus, orderHandleStatus: row.orderHandleStatus },
          });
        }else{
          // 内部订单详情页
          this.$router.push({
            name: 'BusinessOrderInternalViewCSG',
            query: { id: '', code: row.innerOrderNo, status: row.totalOrderStatus, orderHandleStatus: row.orderHandleStatus },
          });
        }
      }
    },
    command(text, row) {
      switch (text) {
        // 跳内部详情页，控制 物流单模块保存 按钮，
        case 'fillInLabel':
          this.$router.push({
            name: 'BusinessOrderInternalViewCSG',
            query: { id: '', code: row.innerOrderNo, status: row.totalOrderStatus, type: 'edit', orderHandleStatus: row.orderHandleStatus },
          });
          break;
        // 弹出框，写入价格并保存
        case 'fillInPrice':
          this.form.innerOrderNo = row.innerOrderNo;
          this.form.totalOrderStatus = row.totalOrderStatus;
          this.form.isDisabled = false;
          this.dialogFormVisible = true;
          break;
        // 弹出框，确认价格或否认价格
        case 'ConfirmPrice':
          this.form = row;
          this.form.isDisabled = true;
          this.dialogFormVisible = true;
          break;
        // 弹出框，修改运输方式
        case 'ModifyTrans':
          getShippingList(row.cusId).then(res=>{
            const array1 = res.filter(item=> !item.isDisable)
            const keyArray = this.$lodash.keyBy(array1, 'value');

            this.Shippingform = JSON.parse(JSON.stringify({
              ...this.Shippingform,
              innerOrderNo:row.innerOrderNo,
              shippingMethod:row.shippingMethod,
              takingDeliveryWay:row.takingDeliveryWay,
              totalOrderStatus:row.totalOrderStatus,
              // isNeedQuota: row.isNeedQuota,
              // isProvideSize: row.isProvideSize,
            }));
            if(row.shippingMethod == 'PICKUP'){
              this.Shippingform.shippingMethod = null
              this.ShippingList = this.$lodash.map([
                { value: 'CUSTOMER MANUAL', label: 'CUSTOMER MANUAL' },
                { value: 'CSG MANUAL', label: 'CSG MANUAL' },
              ],item=>({
                ...keyArray[item.value] || {}
              }))
            }else if(row.shippingMethod == 'CSG MANUAL' || (row.shippingMethod && row.shippingMethod.toLowerCase().includes('csg manual'))){
              this.Shippingform.shippingMethod = null
              this.ShippingList = this.$lodash.map([
                { value: 'CUSTOMER MANUAL', label: 'CUSTOMER MANUAL' },
                { value: 'PICKUP', label: 'PICKUP' },
              ],item=>({
                ...keyArray[item.value] || {}
              }))
            }else if(row.shippingMethod == 'CUSTOMER MANUAL' || (row.shippingMethod && row.shippingMethod.toLowerCase().includes('customer manual'))){
              this.Shippingform.shippingMethod = null
              this.ShippingList = this.$lodash.map([
                { value: 'CSG MANUAL', label: 'CSG MANUAL' },
                { value: 'PICKUP', label: 'PICKUP' },
              ],item=>({
                ...keyArray[item.value] || {}
              }))
            }
            this.dialogShippingVisible = true;
          })
          break;
        // 弹出框，修改 长/宽/高/重
        case 'fillInSize':
          this.SizeForm = JSON.parse(JSON.stringify(row));
          this.dialogSizeVisible = true;
          break;
        case 'cancel':
          this.onDelete(row);
          break;
      }
    },
    // 保存报价 并 关闭编辑弹窗
    saveAmount() {
      this.$refs.form.validate(valid => {
        if (valid) {
          orderApi.waitingUpdatePrice({
            innerOrderNo:this.form.innerOrderNo,
            totalOrderStatus:this.form.totalOrderStatus,
            quotedAmount:this.form.quotedAmount,
          }).then(res => {
              if (res.failed === false) {
                this.dialogFormVisible = false;
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                this.reFresh();
              }
            })
        }
      })
    },
    // 否认报价 并 关闭编辑弹窗
    cancelAmount() {
      this.$confirm(this.$t('WarehouseManagement.form.change'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
        .then(() => {
            orderApi.waitingConfirmPrice({
              innerOrderNo:this.form.innerOrderNo,
              quotaOrNot:3,
              quotedAmount:this.form.quotedAmount,
              totalOrderStatus:this.form.totalOrderStatus,
            }).then(res => {
            if (res.failed === false) {
              this.dialogFormVisible = false;
              this.form.isDisabled = false;
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.reFresh();
            }
          })
        })
    },
    // 确认报价 并 关闭编辑弹窗
    doneAmount() {
      orderApi.waitingConfirmPrice({
          innerOrderNo:this.form.innerOrderNo,
          quotaOrNot:2,
          quotedAmount:this.form.quotedAmount,
          totalOrderStatus:this.form.totalOrderStatus,
        }).then(res => {
        if (res.failed === false) {
          this.dialogFormVisible = false;
          this.form.isDisabled = false;
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.reFresh();
        }
      })
    },
    // 修改物流方式 并 关闭编辑弹窗
    updateShapping() {
      this.$refs.Shippingform.validate(valid => {
        if (valid) {
          orderApi.waitingUpdateShipping(this.Shippingform).then(res => {
              if (res.failed === false) {
                this.Shippingform = {}
                this.dialogShippingVisible = false;
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                this.reFresh();
              }
            })
        }
      })
    },
    // 修改 长/宽/高/重 并 关闭编辑弹窗
    updateSize() {
      this.$refs.SizeForm.validate(valid => {
        if (valid) {
          orderApi.waitingUpdateSize({
            innerOrderNo:this.SizeForm.innerOrderNo,
            totalOrderStatus:this.SizeForm.totalOrderStatus,
            repLength:this.SizeForm.repLength,
            repWidth:this.SizeForm.repWidth,
            repHeight:this.SizeForm.repHeight,
            repWeight:this.SizeForm.repWeight,
          }).then(res => {
              if (res.failed === false) {
                this.dialogSizeVisible = false;
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                this.reFresh();
              }
            })
        }
      })
    },
    // 取消订单
    onDelete(row) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
      .then(() => {
        orderApi.cancelInternalProccessingOrder({ innerOrderNo: row.innerOrderNo }).then(res => {
          if (res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
          }
        });
      })
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime_order = null;
      this.queryParams.storeIdList = null;
      this.queryParams.cusId = null;
      this.queryParams.totalOrderStatus = [8];
      this.defaultSort = [];
      this.queryParams.sortParam = null;
      this.queryParams.sortOrder = null;
      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>

<style scoped>
::v-deep .bj-page .el-form-item__label {
  display: none;
}
</style>
